/* 2.5.0: Your Library (PROTO-2 sv) on the live services. Saved designs: JPState.saved (the live save service keeps it
   in sync with the account); remove/undo: JPSavedDesigns.toggleSaved (or JPState.toggleSaved). A card's print size and
   product id come from the product (section jp-p2-sv-card, Shopify section rendering), cached for this visit.
   Add to set: JPSet.add (first add asks for the pack; a design that does not fit offers the next one), "Put all in a
   set": JPSet.itemFromProduct + JPSet.commit, then JPState.setPlan only when the set needs a bigger pack.
   Take out of the set: JPState.removeItem. Prices: JPState.getPlan (checkout config printed on this page). */
(function () {
  'use strict';
  var root = document.querySelector('[data-jp-p2-sv]');
  if (!root) return;
  var $ = function (s) { return root.querySelector(s); };
  var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MARK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6.5 4h11v16l-5.5-4-5.5 4z"/></svg>';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(n) { return n % 1 ? String(+n.toFixed(1)) : String(n); }
  function inches(l) { var m = /([\d.]+)\s*[×x]\s*([\d.]+)/i.exec(l || ''); return m ? [+m[1], +m[2]] : null; }
  function spN(n) { return n + ' space' + (n === 1 ? '' : 's'); }
  function S() { return window.JPState ? JPState.read() : { plan: 'starter', items: [], saved: [] }; }
  function money(c) {
    var n = Math.round(Number(c) || 0), ct = Math.abs(n % 100) > 0, cur = 'USD';
    try { cur = JPState.getCheckoutConfig(root).currency || 'USD'; } catch (e) {}
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol', minimumFractionDigits: ct ? 2 : 0, maximumFractionDigits: ct ? 2 : 0 }).format(n / 100); }
    catch (e) { return '$' + (n / 100).toFixed(ct ? 2 : 0); }
  }
  function plans() { if (!window.JPState) return []; return JPState.getPlanIds(root).map(function (id) { return JPState.getPlan(id, root); }).sort(function (a, b) { return a.capacity - b.capacity; }); }
  function records() {
    var r = window.JPSavedDesigns && JPSavedDesigns.getAll ? JPSavedDesigns.getAll() : (S().saved || []);
    return (r || []).map(function (x) { return typeof x === 'string' ? { handle: x } : x; }).filter(function (x) { return x && x.handle; });
  }
  function setItems() { return S().items || []; }
  function inSet(h) { return setItems().filter(function (x) { return x.productHandle === h; })[0] || null; }
  function used(items) { return items.reduce(function (a, x) { return a + Math.max(1, Number(x.spaces) || 1) * Math.max(1, Number(x.quantity) || 1); }, 0); }
  function sizeOf(label) { var z = label && window.JPSet && JPSet.sizeFor ? JPSet.sizeFor(label) : null; return z || null; }

  /* ---------- product facts per saved design (section rendering, cached for the visit) ---------- */
  var INFO = {}, waiting = {};
  try { INFO = JSON.parse(sessionStorage.getItem('jp-p2-sv-info') || '{}') || {}; } catch (e) { INFO = {}; }
  function keep() { try { sessionStorage.setItem('jp-p2-sv-info', JSON.stringify(INFO)); } catch (e) {} }
  var queue = [], running = 0;
  function want(h) { if (INFO[h] || waiting[h]) return; waiting[h] = 1; queue.push(h); pump(); }
  function pump() {
    while (running < 4 && queue.length) {
      var h = queue.shift(); running++;
      fetch((root.dataset.products || '/products/') + encodeURIComponent(h) + '?section_id=' + encodeURIComponent(root.dataset.cardSection || 'jp-p2-sv-card'), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { var m = /<script type="application\/json" data-sv-card>([\s\S]*?)<\/script>/.exec(html || ''); return m ? JSON.parse(m[1]) : null; })
        .catch(function () { return null; })
        .then((function (h) { return function (d) { running--; delete waiting[h]; INFO[h] = d || { missing: true }; keep(); schedule(); pump(); }; })(h));
    }
  }
  var raf = 0; function schedule() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; renderSaved(); }); }

  /* ---------- toast ---------- */
  var tt = 0;
  function toast(msg, act, fn) {
    $('#tT').textContent = msg; var a = $('#tA'); a.innerHTML = act || ''; $('#toast').classList.add('on'); clearTimeout(tt);
    var b = a.querySelector('button'); if (b && fn) b.addEventListener('click', function () { fn(); $('#toast').classList.remove('on'); });
    tt = setTimeout(function () { $('#toast').classList.remove('on'); }, 4200);
  }

  /* ---------- the set link ---------- */
  function setLine() {
    var st = S(), p = window.JPState ? JPState.getPlan(st.plan, root) : { capacity: 15 }, u = used(st.items || []);
    $('#svsetn').textContent = u + ' of ' + p.capacity + ' spaces';
  }

  /* ---------- tabs ---------- */
  function tab(k, push) {
    $('#tabs').dataset.t = k;
    [0, 1].forEach(function (i) { $('#tb' + i).setAttribute('aria-selected', String(i === k)); $('#p' + i).hidden = i !== k; });
    if (push) try { history.replaceState(null, '', k ? '#purchased' : location.pathname + location.search); } catch (e) {}
  }
  $('#tb0').addEventListener('click', function () { tab(0, true); });
  $('#tb1').addEventListener('click', function () { tab(1, true); });

  /* ---------- saved ---------- */
  var prevU = null;
  function card(r) {
    var d = INFO[r.handle] || {}, title = r.title || d.title || r.handle.replace(/-/g, ' '), im = r.image || d.img || '', url = r.url || d.url || ((root.dataset.products || '/products/') + r.handle);
    var wh = inches(d.size), z = sizeOf(d.size), on = inSet(r.handle);
    var mt = wh ? fmt(wh[0]) + ' × ' + fmt(wh[1]) + ' in' + (z ? ' · ' + spN(z.spaces) : '') : (INFO[r.handle] ? '' : '&nbsp;');
    var add = d.id ? '<button class="add' + (on ? ' on' : '') + '" type="button" data-add="' + esc(r.handle) + '">' + (on ? 'In your set ✓' : '+ Add to set') + '</button>'
      : '<a class="add" href="' + esc(url) + '">View design</a>';
    return '<div class="sv-it" data-h="' + esc(r.handle) + '"><a class="im" href="' + esc(url) + '">' + (im ? '<img src="' + esc(im) + '" alt="' + esc(title + ' temporary tattoo design') + '" loading="lazy">' : '') + (on ? '<span class="in">In your set</span>' : '') + '</a>' +
      '<button class="hrt" type="button" data-rm="' + esc(r.handle) + '" aria-label="Remove ' + esc(title) + ' from Saved">' + MARK + '</button><b>' + esc(title) + '</b><span class="mt">' + mt + '</span>' + add + '</div>';
  }
  function renderSaved() {
    var R = records(), n = R.length;
    $('#n0').textContent = n;
    if (!n) { $('#p0').innerHTML = (document.getElementById('svEmpty') || {}).innerHTML || ''; prevU = 0; return; }
    R.forEach(function (r) { if (!INFO[r.handle] || (!INFO[r.handle].id && !INFO[r.handle].missing)) want(r.handle); });
    /* the mix: the saves as one set, once every size is known */
    var known = R.map(function (r) { var d = INFO[r.handle], z = d && sizeOf(d.size); return z ? { r: r, d: d, z: z } : null; }).filter(Boolean);
    var tot = known.reduce(function (a, k) { return a + k.z.spaces; }, 0), P = plans(), fit = -1;
    for (var i = 0; i < P.length; i++) if (tot <= P[i].capacity) { fit = i; break; }
    var h = '';
    if (known.length && known.length === R.length && P.length) {
      var top = P[P.length - 1], cap = fit < 0 ? top.capacity : P[fit].capacity;
      var head = fit < 0 ? '<h2>Your saves, two sets</h2><p>These ' + n + ' designs use ' + tot + ' spaces, more than a ' + top.capacity + '-space set. Pick the ones for this set and keep the rest saved.</p>'
        : '<h2>Your saves, one set</h2><p>' + n + ' design' + (n === 1 ? '' : 's') + ' use' + (n === 1 ? 's' : '') + ' ' + tot + ' of ' + cap + ' spaces' + (cap - tot > 0 ? ', with ' + (cap - tot) + ' left for a name, a date or your own art.' : '.') + ' Every space can be a different design.</p>';
      var cells = ''; if (fit === 0) { for (var c = 0; c < P[0].capacity; c++) cells += '<i class="' + (c < tot ? 'u' : '') + (prevU !== null && c >= prevU && c < tot ? ' n' : '') + '"></i>'; }
      prevU = tot;
      h += '<div class="sv-mix"><div><div class="top"><div><small>Saved · ' + n + ' design' + (n === 1 ? '' : 's') + '</small>' + head + '</div>' + (fit >= 0 ? '<div class="px">' + money(P[fit].priceCents) + '<span>' + P[fit].capacity + ' spaces</span></div>' : '') + '</div>' +
        (fit === 0 ? '<div class="sv-cells" aria-hidden="true" style="margin-top:12px">' + cells + '</div>' : '') + '</div><div class="act"><button class="btn blue" type="button" id="allIn">' + (fit < 0 ? 'Put the first ' + top.capacity + ' spaces in a set' : 'Put all ' + n + ' in a set') + '</button></div></div>';
      h += '<div class="sv-bar"><span>' + n + ' saved · ' + tot + ' spaces at suggested sizes</span>' + ((document.getElementById('svSizes') || {}).innerHTML || '') + '</div>';
    }
    h += '<div class="sv-grid">' + R.map(card).join('') + '</div>';
    $('#p0').innerHTML = h;
  }
  function product(r) {
    var d = INFO[r.handle] || {};
    return { id: d.id, productId: d.id, productHandle: r.handle, title: d.title || r.title, image: d.img960 || d.img || r.image, sizeLabel: d.size, designCode: d.code || r.code || '', style: d.style || '' };
  }
  $('#p0').addEventListener('click', function (e) {
    var b;
    if ((b = e.target.closest('[data-rm]'))) {
      var h = b.dataset.rm, rec = records().filter(function (r) { return r.handle === h; })[0]; if (!rec) return;
      var it = b.closest('.sv-it'); if (it && !calm) it.classList.add('out');
      setTimeout(function () {
        var tog = window.JPSavedDesigns && JPSavedDesigns.toggleSaved ? JPSavedDesigns.toggleSaved : (window.JPState && JPState.toggleSaved);
        if (!tog) return;
        tog(rec); renderSaved();
        toast('Removed from Saved', '<button type="button">Undo</button>', function () { tog(rec); renderSaved(); });
      }, calm ? 0 : 220);
      return;
    }
    if ((b = e.target.closest('[data-add]'))) {
      var hd = b.dataset.add, x = inSet(hd);
      if (x) { if (window.JPState) JPState.removeItem(x.id, 'p2-saved-take-out'); renderSaved(); setLine(); toast('Taken out of your set'); return; }
      var rr = records().filter(function (r) { return r.handle === hd; })[0]; if (!rr || !window.JPSet) return;
      var card0 = b.closest('.sv-it'), src = card0 && card0.querySelector('img');
      var ok = JPSet.add(product(rr), { src: src });
      if (ok) { renderSaved(); setLine(); var st = S(), p = JPState.getPlan(st.plan, root); toast('Added · ' + used(st.items || []) + ' of ' + p.capacity + ' spaces used', '<a href="' + esc(root.dataset.cartUrl || '/cart') + '">Review set</a>'); }
      return;
    }
    if ((b = e.target.closest('#allIn'))) {
      if (!window.JPSet || !JPSet.commit || !JPSet.itemFromProduct || !window.JPState) return;
      var P = plans(), max = P.length ? P[P.length - 1].capacity : 72, u = used(setItems()), added = 0;
      records().forEach(function (r) {
        var d = INFO[r.handle], z = d && sizeOf(d.size); if (!z || !d.id || inSet(r.handle)) return;
        if (u + z.spaces > max) return;
        if (JPSet.commit(JPSet.itemFromProduct(product(r), z), null, true)) { u += z.spaces; added++; }
      });
      var need = JPState.minimumPlanForSpaces(u, root), cur = JPState.getPlan(S().plan, root);
      if (need && u > cur.capacity) JPState.setPlan(need, 'p2-saved-all-in');
      location.href = root.dataset.cartUrl || '/cart';
    }
  });

  /* ---------- purchased ---------- */
  var cpy = document.getElementById('cpy');
  if (cpy) cpy.addEventListener('click', function () { var t = cpy.textContent.trim(); (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function () { toast('Email copied'); }, function () { toast(t); }); });

  function all() { renderSaved(); setLine(); }
  function start() {
    all();
    if (location.hash === '#purchased') tab(1, false);
    document.addEventListener('justpress:saved-change', all);
    document.addEventListener('justpress:saved-ready', all);
    document.addEventListener('justpress:state-change', all);
    window.addEventListener('storage', all);
  }
  /* deferred page scripts run before the layout's jp-state-store.js: wait for the engine (DOMContentLoaded comes after every deferred script) */
  if (window.JPState) start(); else { var go = function () { if (!go.done) { go.done = 1; start(); } }; document.addEventListener('DOMContentLoaded', go); addEventListener('load', go); }
})();
